//CRIANDO ACTION

import { createAction, props } from '@ngrx/store';
import { IContabilidade } from 'src/app/shared/interfaces/contabilidade/icontabilidade';

//padrão de nomenclatura tudo maiusculo
enum ContabilidadeActionType {
  //textos para acomparnharmos os estados de load contabilidade
  LOAD_CONTABILIDADE = '[contabilidade] load contabilidade from api',
  LOAD_CONTABILIDADE_SUCCESS = '[contabilidade] load contabilidade from api return success',
  LOAD_CONTABILIDADE_ERROR = '[contabilidade] load contabilidade from api return error',
  SAVE_CONTABILIDADE = '[contabilidade] save contabilidade from api',
  SAVE_CONTABILIDADE_SUCCESS = '[contabilidade] edit contabilidade from api return success',
  EDIT_CONTABILIDADE = '[contabilidade] edit contabilidade from api',
  EDIT_CONTABILIDADE_SUCCESS = '[contabilidade] edit contabilidade from api return success',
  DELETE_CONTABILIDADE = '[contabilidade] delete contabilidade from api',
}
export const loadContabilidade = createAction(
  ContabilidadeActionType.LOAD_CONTABILIDADE
);
export const loadContabilidadeSuccess = createAction(
  ContabilidadeActionType.LOAD_CONTABILIDADE_SUCCESS,
  props<{ lista: IContabilidade[] }>()
);
//vai para o effects
export const saveContabilidade = createAction(
  ContabilidadeActionType.SAVE_CONTABILIDADE,
  props<{ contabilidade: IContabilidade }>()
);
//vai para o reducer
export const saveContabilidadeSuccess = createAction(
  ContabilidadeActionType.SAVE_CONTABILIDADE_SUCCESS,
  props<{ contabilidade: IContabilidade }>()
);
//vai para o effects
export const editContabilidade = createAction(
  ContabilidadeActionType.EDIT_CONTABILIDADE,
  props<{ contabilidade: IContabilidade; id: number }>()
);
//vai para o reducer
export const editContabilidadeSuccess = createAction(
  ContabilidadeActionType.EDIT_CONTABILIDADE_SUCCESS,
  props<{ contabilidade: IContabilidade }>()
);

export const deleteContabilidade = createAction(
  ContabilidadeActionType.DELETE_CONTABILIDADE,
  props<{ id: number }>()
);
